import { StyledCard } from '@app/components/StyledCard';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { PropsWithChildren } from 'react';

export function SocialPlatformCard({
  platform,
  children,
}: PropsWithChildren<{
  platform: SocialPlatform;
}>) {
  return <StyledCard>{children}</StyledCard>;
}
